import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Shield } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import api from "../lib/api";
import { toast } from "sonner";
import { LOGO_URL } from "../lib/contact";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (localStorage.getItem("na_admin_token")) {
      navigate("/admin");
    }
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    if (!password) {
      toast.error("Bitte Passwort eingeben.");
      return;
    }
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { password });
      localStorage.setItem("na_admin_token", res.data.token);
      toast.success("Willkommen im Admin-Dashboard");
      navigate("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login fehlgeschlagen";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--na-bg)] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <img src={LOGO_URL} alt="NA Automobile" className="h-12 w-auto mb-6" />
          <p className="text-[11px] uppercase tracking-[0.3em] text-zinc-500">Internal</p>
          <h1 className="font-display text-3xl font-bold text-white mt-2 tracking-tight">Admin Dashboard</h1>
        </div>

        <form onSubmit={submit} className="bg-[#232330] border border-white/10 rounded-2xl p-8 space-y-5">
          <div className="w-12 h-12 mx-auto rounded-xl bg-[var(--na-red)]/15 text-[var(--na-red)] flex items-center justify-center">
            <Shield className="w-5 h-5" strokeWidth={1.7} />
          </div>
          <div>
            <Label className="text-[11px] uppercase tracking-widest text-zinc-400 mb-2 block">Passwort</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
              <Input
                type="password"
                data-testid="admin-login-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-[#1A1A22] border-white/10 text-white pl-10 focus-visible:ring-[var(--na-red)] focus-visible:border-[var(--na-red)]"
                placeholder="••••••••"
                autoFocus
              />
            </div>
          </div>
          <Button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full bg-[var(--na-red)] hover:bg-[var(--na-red-hover)] text-white font-medium tracking-wide rounded-xl py-3">
            {loading ? "Anmelden…" : "Anmelden"}
          </Button>
        </form>

        <p className="text-xs text-zinc-500 text-center mt-6">
          Geschützter Bereich · Nur autorisierter Zugriff
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
